import { render, staticRenderFns } from "./PreviewedFormatSelector.vue?vue&type=template&id=4fc89d82&scoped=true&"
import script from "./PreviewedFormatSelector.vue?vue&type=script&lang=ts&"
export * from "./PreviewedFormatSelector.vue?vue&type=script&lang=ts&"
import style0 from "./PreviewedFormatSelector.vue?vue&type=style&index=0&id=4fc89d82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc89d82",
  null
  
)

export default component.exports